import { useEffect, useRef, useMemo } from "react";
import { LoaderMedium } from "../../components/loader";

const InfiniteListWrapper = ({
  dataLength,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
  isLoading,
  emptyMessage = "No data found",
  emptyImage = null,
  enableManualLoad = true,
  children,
}) => {
  const loaderRef = useRef(null);

  // ✅ Browser capability check (runs once)
  const supportsObserver = useMemo(
    () => typeof window !== "undefined" && "IntersectionObserver" in window,
    []
  );

  useEffect(() => {
    if (!supportsObserver) return;
    if (!loaderRef.current || !hasNextPage) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && hasNextPage) {
          fetchNextPage();
        }
      },
      { threshold: 1 }
    );

    observer.observe(loaderRef.current);

    return () => observer.disconnect();
  }, [supportsObserver, hasNextPage, fetchNextPage]);

  // Initial loading
  if (isLoading) {
    return (
      <div className="text-center mt-5 mb-5">
        <LoaderMedium size={65} />
      </div>
    );
  }

  // Empty state
  // if (!dataLength) {
  //   return (
  //     <div className="no-fellow text-center mt-4">
  //       {emptyImage && <img src={emptyImage} alt="No Data" />}
  //       <p className="pt-4 head">{emptyMessage}</p>
  //     </div>
  //   );
  // }

  return (
    <>
      {children}
      {/* {!dataLength && (
        <div className="no-fellow text-center mt-4">
          {emptyImage && <img src={emptyImage} alt="No Data" />}
          <p className="pt-4 head">{emptyMessage}</p>
        </div>
      )} */}
      {hasNextPage && (
        <div className="text-center mt-3">
          {/* Observer trigger */}
          {supportsObserver && <div ref={loaderRef} />}

          {/* Manual fallback */}
          {enableManualLoad && (!supportsObserver || true) && (
            <button
              className="btn btn-primary mt-2"
              disabled={isFetchingNextPage}
              onClick={() => fetchNextPage()}
            >
              {isFetchingNextPage ? "Loading..." : "Load More"}
            </button>
          )}

          {isFetchingNextPage && <LoaderMedium />}
        </div>
      )}
    </>
  );
};

export default InfiniteListWrapper;